<template>
  <div class="max-w-600 md:ml-12">
    <div class="title">{{ content.title }}</div>
    <div v-clickOutside="close" class="relative w-full mb-4">
      <transition name="cascader">
        <div v-show="cascaderVisible" class="warpper absolute">
          <MCascader
            v-model="cascaderValue"
            :options="options"
            value="text"
            @close="show = false"
            @finish="onFinish"
          />
        </div>
      </transition>
      <div
        :class="['select-warpper', cascaderVisible ? 'active' : '', disabled ? 'disabled' : '']"
        @click="handleOpen"
      >
        <input
          v-model.trim="selectValue"
          readonly
          placeholder="请选择"
          type="text"
          class="select cursor-pointer"
        />
        <ArrowsIcon :class="['arrows-icon w-4 h-4']" />
      </div>
      <transition name="input">
        <div
          v-show="inputVisible || otherValue"
          :class="['other-text', otherSubmit || disabled ? 'other-submit' : '']"
        >
          <textarea
            ref="textarea"
            v-model="otherValue"
            :readonly="otherSubmit || disabled"
            class="other-textarea"
          ></textarea>
          <div v-show="!otherSubmit && !disabled" class="button-warpper">
            <button class="other-button" @click="handleComfirm">确定</button>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';
import clickOutside from 'vue-click-outside';

import { Cascader as MCascader } from 'vant';
import ArrowsIcon from './assets/ArrowsIcon.vue';
import { Content } from '@forchange/storytime';

import GET_LOCAL from './graphql/getLocal';

type CascaderData = Array<{ text: string; value?: string; children: CascaderData }>;

@Component({
  components: {
    MCascader,
    ArrowsIcon
  },
  directives: {
    clickOutside
  }
})
export default class Cascader extends Vue {
  @Prop({ type: Object }) content: Content & {
    title: string;
    type: string;
    otherSelect: string;
    notRequired: string;
    data: CascaderData;
    otherValue: string;
    selectArr: Array<string>;
  };
  cascaderValue = '';
  selectValue = '';
  selectsourceValue: Object;
  cascaderVisible = false;
  inputVisible = false;
  otherValue = '';

  // 手动生成id
  codeIndex = 0;

  // 当前多选题max_level
  maxLevel = 0;

  options = [];

  get disabled() {
    return this.content.$id !== window.storyteller.topContet?.$id;
  }

  get otherSubmit() {
    return Boolean(this.$store.state.cascader.otherValue);
  }

  get otherSelect() {
    return ['true', '是'].includes(this.content.otherSelect);
  }

  mounted() {
    this.initData();
    this.initOption();
  }

  initData() {
    this.otherValue = this.content.otherValue || '';
    if (this.content.selectArr) this.selectValue = this.content.selectArr.join('/');
  }

  async initOption() {
    // 只有在非禁用情况加加载选项
    if (this.disabled) return;
    this.$store.commit('cascader/setdurationStart', new Date().getTime());
    if (this.content.type === '自定义') {
      if (!this.content.data)
        return this.$Message.warn({
          time: 1500,
          content: '选择自定义类型必须要填写‘数据’选项'
        });
      this.options = this.makeOption(this.content.data);
    } else {
      await this.makeRemoteData();
    }
    this.$store.commit('cascader/setMaxLevel', this.maxLevel);
  }

  async makeRemoteData() {
    try {
      const localData = await this.$getClemanClient().apollo.query({
        query: GET_LOCAL,
        variables: {
          name: this.content.type
        }
      });
      this.options = this.makeOption(localData.data.cascadeOption.value);
    } catch (error) {
      this.$Message.warn({
        time: 1500,
        content: '所选类型可能不存在，请和相关人员确认一下'
      });
      console.log('error: ', error);
    }
  }

  makeOption(data: CascaderData, level = 1) {
    if (level > this.maxLevel) this.maxLevel = level;
    const option: any = data.map((item) => {
      if (item.children) {
        return {
          text: item.text,
          value: this.codeIndex++,
          children: this.makeOption(item.children, level + 1)
        };
      }
      return {
        text: item.text,
        value: this.codeIndex++
      };
    });
    if (this.otherSelect) {
      option.push({
        text: '其他'
      });
    }

    return option;
  }

  onFinish(value: { value: string; selectedOptions: Array<{ text: string }> }) {
    this.cascaderVisible = false;
    if (value.value !== undefined) {
      this.$store.commit('cascader/setOtherValue', '');
      this.otherValue = '';
      this.inputVisible = false;
      this.$store.commit('cascader/setSubmitState', true);
    } else {
      this.inputVisible = true;
      (this.$refs.textarea as HTMLTextAreaElement).focus();
      this.$store.commit('cascader/setSubmitState', false);
      this.$emit('loaded');
    }

    this.selectValue = this.markInput(value.selectedOptions);
  }

  markInput(selectedOptions: Array<{ text: string }>) {
    const selectArr = selectedOptions.map((item) => {
      return item.text;
    });
    this.$store.commit('cascader/setSelectArr', selectArr);
    return selectArr.join('/');
  }

  handleOpen() {
    if (this.disabled) return;
    this.cascaderVisible = !this.cascaderVisible;
  }

  close() {
    this.cascaderVisible = false;
  }

  handleComfirm() {
    this.$store.commit('cascader/setOtherValue', this.otherValue);
    this.$store.commit('cascader/setSubmitState', true);
  }
}
</script>
<style scoped>
.title {
  @apply font-medium mb-3;
  color: #1a051d;
  font-size: 18px;
}
.warpper {
  @apply rounded-motif overflow-hidden pt-2 mb-3 w-full bottom-full left-0 bg-white;
  border: 1px solid #d3d3d3;
}

.select-warpper {
  @apply relative mb-3;
}

.select {
  @apply w-full rounded-lg shadow-none text-lg;
  border: 1px solid #d3d3d3;
  outline: none !important;
  box-shadow: none;
}

.active .select {
  border-color: var(--motif-400);
}
.select-warpper:hover .select {
  border-color: var(--motif-400);
}
.select-warpper,
.disabled:hover .select {
  border-color: #d3d3d3;
}

.arrows-icon {
  @apply absolute right-4 top-1/2;
  transform: translateY(-50%);
  transition: 0.2s;
}

.active .arrows-icon {
  transform: rotate(180deg);
  transform-origin: center 25%;
  fill: var(--motif-400);
}

.active .arrows-icon /deep/ path {
  fill: var(--motif-400);
}
.select-warpper:hover .arrows-icon /deep/ path {
  fill: var(--motif-400);
}
.select-warpper,
.disabled:hover .arrows-icon /deep/ path {
  fill: #d3d3d3;
}

.other-text {
  @apply flex flex-col items-end h-36 w-full rounded-lg resize-none overflow-hidden;
  border: 1px solid var(--motif-400);
}

.other-submit {
  @apply h-auto max-h-36;
  border-color: #d3d3d3;
}

.other-textarea {
  @apply resize-none border-none w-full flex-1;
  outline: none !important;
  box-shadow: none;
}

.button-warpper {
  flex: 0 36px;
}

.other-button {
  @apply w-16 h-8 rounded-full bg-motif text-white font-medium mr-2;
}

.warpper /deep/ .van-cascader__options {
  @apply max-h-60 text-lg;
}

.warpper /deep/ .van-cascader__option {
  line-height: 12px;
}

.warpper /deep/ .van-tab__text {
  @apply text-lg;
}

.warpper /deep/ .van-cascader__header {
  display: none;
}

.warpper /deep/ .van-tabs__line {
  background: var(--motif-gradient);
  transform: translateX(37px) translateX(-50%);
  transition-duration: 0.3s;
}

.warpper /deep/ .van-cascader__tabs.van-tabs--line .van-tabs__wrap {
  @apply h-9;
}

.warpper /deep/ .van-cascader__option--selected {
  @apply text-motif-500;
}
.warpper /deep/ .van-cascader__tab--unselected {
  @apply text-motif-500 font-medium;
}

/* .warpper /deep/ .van-tabs__wrap .van-tabs__wrap--scrollable::after {
  content: ' ';
  @apply h-px bg-black;
} */

@screen md {
  .warpper /deep/ .van-cascader__option:hover {
    background: #f6f6ff;
  }
}

.cascader-enter,
.cascader-leave-to {
  opacity: 0;
}
.cascader-enter-active,
.cascader-leave-active {
  transition: 0.2s;
}

.input-enter {
  opacity: 0;
}
.input-leave-to {
  height: 0;
  opacity: 0;
}
.input-enter-active,
.input-leave-active {
  transition: 0.2s;
}

.other-submit-leave-to {
  height: 0;
  opacity: 0;
}
.other-submit-leave-active {
  transition: 0.2s;
}
</style>
